import {
  ACTION_UPLOAD_SITE_GOOGLE_TOOL_FILE__REQUEST,
  ACTION_UPLOAD_SITE_GOOGLE_TOOL_FILE__SUCCESS,
  ACTION_UPLOAD_SITE_GOOGLE_TOOL_FILE__FAIL,
} from '../../actionTypes';


export default (state = null, action) => {
  switch (action.type) {
    case ACTION_UPLOAD_SITE_GOOGLE_TOOL_FILE__REQUEST:
    case ACTION_UPLOAD_SITE_GOOGLE_TOOL_FILE__SUCCESS:
      return null;

    case ACTION_UPLOAD_SITE_GOOGLE_TOOL_FILE__FAIL:
      return action.payload.error;

    default:
      return state;
  }
};
